import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { MASTER_BANK_ID, REFERRAL_BANK_ID } from '@utils/static';
import { icons } from '@shared/static/icons';
import { formatBalanceUi } from '@utils/balance-helpers';
import { useTransferDialog } from '@utils/dialogs-hooks';

export default function ReferralsStats() {
  const { t } = useTranslation();
  const { statistic } = useSelector((state) => state.referrals);
  const { openTransferDialog } = useTransferDialog();

  const stats = [
    {
      label: t('Current referral income'),
      value: formatBalanceUi(
        statistic?.current_referral_balance ?? 0,
        'USD',
        null,
        true,
      ),
    },
    {
      label: t('Total referral income'),
      value: formatBalanceUi(statistic?.total_revenue ?? 0, 'USD', null, true),
    },
    { label: t('Referral rate'), value: `${statistic?.rate ?? 0}%` },
    { label: t('Referrals'), value: statistic?.count ?? 0 },
  ];

  return (
    <div>
      <div className="referralsStats block-pd-x">
        {stats.map((item) => (
          <div key={item.label} className="referralsStats__item">
            <p className="body-18m">{item.label}</p>
            <p
              className="title-h1r"
              dangerouslySetInnerHTML={{ __html: item.value }}
            />
          </div>
        ))}
      </div>
      <div className="block-pd-x referralsStats__withdraw">
        <button
          type="button"
          className="dashed-btn"
          onClick={() =>
            openTransferDialog({
              bank_id: MASTER_BANK_ID,
              bank_from: REFERRAL_BANK_ID,
            })
          }
        >
          {icons['arrow-down']} {t('Withdraw')}
        </button>
      </div>
    </div>
  );
}
